import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgError500 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 200,
	height: 200,
	fill: "none",
	viewBox: "0 0 200 200",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#error-500_svg__paint0_linear_4022_3687)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M123.52 175h14.33v-24.9"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#error-500_svg__paint1_linear_4022_3687)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M137.85 121.47V53.55a44.14 44.14 0 0 0-71-35.03"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-accent, #A81A6A)",
			d: "M49.58 174.98v.03h.08z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-accent, #A81A6A)",
			d: "M93.72 9.41a44 44 0 0 0-26.86 9.11q3.09-1.32 6.4-1.9c21.63-3.73 36.67 11.1 36.67 28.17v57.47a80 80 0 0 0 6.1-11.18c.18-4.84-.74-12.97-1.37-18.59l10.64-2.94c.73 7.38.85 23.13-.58 27.04a38 38 0 0 1-3.96 5.95l12.06-1.89q2.56 10.4 5.04 20.82V53.55A44.15 44.15 0 0 0 93.72 9.41"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-accent, #A81A6A)",
			d: "M122.7 132.75a57 57 0 0 1-1.56 3.07c1.71 12.76 2.3 23.44 3.7 36.23l-1.7.23q.2 1.31.38 2.73h14.34V150.1a30.6 30.6 0 0 1-15.16-17.35"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#error-500_svg__paint2_linear_4022_3687)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M184.47 154.52a63 63 0 0 0-9.78-4.83l-5.3 10.14a9.3 9.3 0 0 1 1.7 8.6c-.68 2.63-4.34 11.12-2.6 12.6 2.48 2.1 9.92-5.3 13.88-14.22 1.45-3.26 4.5-10.61 2.1-12.29"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#error-500_svg__paint3_linear_4022_3687)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M122.7 132.75a30.6 30.6 0 0 0 15.95 17.74c9.61 4.49 19.53 8.88 29.38 11.94l7.44-14.22c-13.9-9.1-19.37-12.72-34.96-15.74-1.7-6.87-4.55-19.1-7.7-31.81"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-accent, #A81A6A)",
			d: "m136.47 131.89 4.04.58-.4-1.6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#error-500_svg__paint4_linear_4022_3687)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m136.47 131.89 4.04.58-.4-1.6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-shade, #FF6642)",
			d: "M116.02 91.08c.18-4.84-.73-12.97-1.36-18.59l10.63-2.94c.74 7.38.85 23.13-.58 27.04a38 38 0 0 1-3.96 5.95l13.25-2.07S131.87 89.6 131.11 86c-5.74-27.35-11.46-35-21.19-36.82v53.08a79 79 0 0 0 6.1-11.18"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#error-500_svg__paint5_linear_4022_3687)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m120.75 102.54 13.25-2.07S131.87 89.6 131.11 86c-5.74-27.35-11.46-35-21.19-36.82"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#error-500_svg__paint6_linear_4022_3687)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M109.93 186.33c4.3.03 8.42.03 12.59-.02a1.9 1.9 0 0 0 1.9-1.99c-.12-3.41-.7-8.16-1.3-12.04"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#error-500_svg__paint7_linear_4022_3687)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M109.93 173.9c4.72-.6 10.93-1.3 14.92-1.85-1.42-12.8-2-23.47-3.72-36.23 2.5-4.46 9.94-20.89 11.19-35.09l-11.57 1.81"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#error-500_svg__paint8_linear_4022_3687)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M164.83 101.62h11.59"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#error-500_svg__paint9_linear_4022_3687)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M170.62 107.42v-11.6"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#error-500_svg__paint10_linear_4022_3687)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m18.3 119.87 8.2 8.2"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#error-500_svg__paint11_linear_4022_3687)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m18.3 128.07 8.2-8.2"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#error-500_svg__paint12_linear_4022_3687)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m7.33 150.39 4.18 4.18"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#error-500_svg__paint13_linear_4022_3687)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m7.33 154.57 4.18-4.18"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#error-500_svg__paint14_linear_4022_3687)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m130.1 7.92 3.59 5.9L137.9 5"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#error-500_svg__paint15_linear_4022_3687)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M186.35 126.53h6.32"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#error-500_svg__paint16_linear_4022_3687)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M189.5 129.69v-6.32"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#error-500_svg__paint17_linear_4022_3687)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M109.93 102.26V44.8c0-17.07-15.04-31.9-36.67-28.16a28.54 28.54 0 0 0-23.68 28.13v130.22l57.09 19.99 3.25.03v-59.87"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#error-500_svg__paint18_linear_4022_3687)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M106.67 107.81V44.8a28.57 28.57 0 0 0-33.41-28.16"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#error-500_svg__paint19_linear_4022_3687)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M106.67 194.97v-58.53"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-accent, #A81A6A)",
			d: "M97.05 106.44h-2.18c1.63 0 2.96 2.3 2.96 5.14s-1.33 5.13-2.96 5.13h2.18c1.64 0 2.96-2.3 2.96-5.13s-1.32-5.14-2.96-5.14"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#error-500_svg__paint20_linear_4022_3687)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M97.05 106.44h-2.18c1.63 0 2.96 2.3 2.96 5.14s-1.33 5.13-2.96 5.13h2.18c1.64 0 2.96-2.3 2.96-5.13s-1.32-5.14-2.96-5.14"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#error-500_svg__paint21_linear_4022_3687)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M94.87 106.44c-1.64 0-2.97 2.3-2.97 5.14s1.33 5.13 2.97 5.13c1.63 0 2.96-2.3 2.96-5.13s-1.33-5.14-2.96-5.14"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#error-500_svg__paint22_linear_4022_3687)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m125.3 69.55-10.64 2.94c.63 5.62 1.54 13.75 1.36 18.6-4.5 9.51-4.24 7.62-8.74 15.75-2.75 4.63-9.6 12.12-10.9 17.27-.58 2.26-.74 4.85.7 4.85 1.1 0 3.03-6.23 2.98-5.16-.05 4.3.77 8.59 2.4 12.58a1.4 1.4 0 0 0 1.8.77 1.4 1.4 0 0 0 .85-1.75 39 39 0 0 1-2.22-8.77c.96 4.57 1.3 5.88 4.02 10.19a1.42 1.42 0 0 0 2.55-.53q.1-.57-.22-1.06a57 57 0 0 1-3.37-9.5c.75 2.24 1.57 6.55 3.91 9.26a1.41 1.41 0 0 0 2.36-1.57c-1.64-3.13-2.38-3.98-3.47-7.76a26 26 0 0 0 2.36 5.63 1.4 1.4 0 0 0 1.47.73 1.44 1.44 0 0 0 .98-2.15 42 42 0 0 1-3.42-12.97c-.07-.9 13.53-17.24 14.65-20.3 1.43-3.92 1.32-19.67.58-27.05"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#error-500_svg__paint23_linear_4022_3687)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m111 69.7.26 3.72 15.54-4.3"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "error-500_svg__paint0_linear_4022_3687",
				x1: 130.688,
				x2: 129.653,
				y1: 171.304,
				y2: 154.669,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "error-500_svg__paint1_linear_4022_3687",
				x1: 102.355,
				x2: 98.122,
				y1: 104.802,
				y2: 29.907,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "error-500_svg__paint2_linear_4022_3687",
				x1: 176.693,
				x2: 175.306,
				y1: 176.674,
				y2: 155.508,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "error-500_svg__paint3_linear_4022_3687",
				x1: 149.084,
				x2: 147.351,
				y1: 153.238,
				y2: 111.894,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "error-500_svg__paint4_linear_4022_3687",
				x1: 138.49,
				x2: 138.475,
				y1: 132.231,
				y2: 131.165,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "error-500_svg__paint5_linear_4022_3687",
				x1: 121.963,
				x2: 119.139,
				y1: 94.606,
				y2: 59.047,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "error-500_svg__paint6_linear_4022_3687",
				x1: 117.177,
				x2: 116.849,
				y1: 184.256,
				y2: 174.831,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "error-500_svg__paint7_linear_4022_3687",
				x1: 121.12,
				x2: 115.455,
				y1: 163.025,
				y2: 114.624,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "error-500_svg__paint8_linear_4022_3687",
				x1: 170.623,
				x2: 170.621,
				y1: 102.473,
				y2: 101.803,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "error-500_svg__paint9_linear_4022_3687",
				x1: 171.122,
				x2: 168.372,
				y1: 105.693,
				y2: 99.065,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "error-500_svg__paint10_linear_4022_3687",
				x1: 22.394,
				x2: 22.198,
				y1: 126.849,
				y2: 121.362,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "error-500_svg__paint11_linear_4022_3687",
				x1: 22.394,
				x2: 22.198,
				y1: 126.849,
				y2: 121.362,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "error-500_svg__paint12_linear_4022_3687",
				x1: 9.421,
				x2: 9.321,
				y1: 153.944,
				y2: 151.145,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "error-500_svg__paint13_linear_4022_3687",
				x1: 9.421,
				x2: 9.321,
				y1: 153.944,
				y2: 151.145,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "error-500_svg__paint14_linear_4022_3687",
				x1: 134.002,
				x2: 133.763,
				y1: 12.514,
				y2: 6.605,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "error-500_svg__paint15_linear_4022_3687",
				x1: 189.509,
				x2: 189.505,
				y1: 127.382,
				y2: 126.711,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "error-500_svg__paint16_linear_4022_3687",
				x1: 190.008,
				x2: 189.095,
				y1: 128.75,
				y2: 124.718,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "error-500_svg__paint17_linear_4022_3687",
				x1: 79.751,
				x2: 67.149,
				y1: 168.384,
				y2: 49.733,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "error-500_svg__paint18_linear_4022_3687",
				x1: 89.962,
				x2: 83.988,
				y1: 94.19,
				y2: 33.359,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "error-500_svg__paint19_linear_4022_3687",
				x1: 107.167,
				x2: 91.917,
				y1: 186.264,
				y2: 178.989,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "error-500_svg__paint20_linear_4022_3687",
				x1: 97.438,
				x2: 96.948,
				y1: 115.182,
				y2: 108.331,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "error-500_svg__paint21_linear_4022_3687",
				x1: 94.866,
				x2: 94.44,
				y1: 115.182,
				y2: 108.322,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "error-500_svg__paint22_linear_4022_3687",
				x1: 110.892,
				x2: 107.211,
				y1: 127.341,
				y2: 82.125,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "error-500_svg__paint23_linear_4022_3687",
				x1: 118.896,
				x2: 118.868,
				y1: 72.785,
				y2: 69.904,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			})
		] })
	]
});
export default SvgError500;
